import React, { useState, useImperativeHandle, forwardRef,useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { TextareaField, AntdButton, DatePickerField, SelectInput } from "../blueplanitUtils/InputField";
import { fetchAdminReport } from "../Slices/employeereportslice";
import { setLoader } from "../Slices/loaderSlice";
import { getOptionsByPath } from "../utilsdata";
import { RECORDS, SLA_MISSED, TASKS, TIMEZONE, AGENCY_INFORMATION, PRODUCTIVE_TYPE, CLIENT_SERVICESASSIGNED, CLIENT_INFO, SALES_RECORDS } from "../Dropdownmanager";

const EmployeeReportFilter = forwardRef((props, ref) => {
  const { PageChange } = props;
  const location = useLocation();
  const currentPage = location.pathname;
  const dispatch = useDispatch();
  const Employee = useSelector((state) => state.employee.AllEmployees);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const clientOptions = useSelector((state) => state.clients.clients);
  const today = dayjs();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [emailId, setEmailId] = useState("");
  const [clientName, setClientName] = useState();
  const [ReportingTo, setReportingTo] = useState();
  const [task, setTask] = useState();
  const [service, setService] = useState();
  const [request, setRequest] = useState("");
  const [billable, setBillable] = useState("both");
  const [status, setStatus] = useState("");
  const [SIA, setSIA] = useState();
  const [timezone, setTimezone] = useState();
  const [productivetype, setProductivetype] = useState();
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [requestReceivedDate, setRequestReceivedDate] = useState(null);
  const [requestCompletedDate, setRequestCompletedDate] = useState(null);


  const billableOptions = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
    { value: "both", label: "Both" },
  ];

  const statusOptions = [
    { value: "open", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "", label: "Both" },
  ];
  const taskOptions = getOptionsByPath(NestedDatabucket, [RECORDS, TASKS]);
  const siaOptions = getOptionsByPath(NestedDatabucket, [RECORDS, SLA_MISSED]);
  const timeZoneOptions = getOptionsByPath(NestedDatabucket, [AGENCY_INFORMATION, TIMEZONE]);
  const productiveTypeOptions = getOptionsByPath(NestedDatabucket, [SALES_RECORDS, PRODUCTIVE_TYPE]);
  const serviceOptions = getOptionsByPath(NestedDatabucket, [CLIENT_INFO, CLIENT_SERVICESASSIGNED]);

  const employeeOptions = Employee.filter((user) => {
    if (currentPage === "/SalesReport") {
      return (user.department === "Sales" || user.department === "Both") && user.employeestatus === "Active";
    }
    if (currentPage === "/ClientReport") {
      return (
        (user.department === "Operations" || user.department === "Both") && user.employeestatus === "Active"
      );
    }
    return user.employeestatus === "Active";
  }).map((user) => ({
    value: user.id,
    label: `${user.firstname} ${user.lastname}`,
  }));

  useEffect(() => {
    if (currentPage === "/SalesReport") {
      setSelectedEmployee(null);
      setEmailId(null)
      setTask(null);
      setService(null);
      setFromDate(today) 
      setToDate(today)
    }
    if(currentPage === "/ClientReport"){
      setSelectedEmployee(null);
      setEmailId(null)
      setReportingTo(null);
      setTask(null);
      setFromDate(today)
      setToDate(today)
    }
  }, [currentPage]);

  const ReportManagers = [
    ...[...new Set(
      Employee?.filter((e) => e.employeestatus === "Active")?.map(e => e.reportingTo?.trim()).filter(Boolean)
    )].map(manager => ({ value: manager, label: manager }))
  ];
  const handleEmployeeSelect = (value) => {
    setSelectedEmployee(value);
    setReportingTo();
  };
  const handleReportingManagerSelect = (value) => {
    setReportingTo(value);
    setSelectedEmployee(null)
  };

  const handleBillableChange = (value) => {
    setBillable(value);
    setTask();
  };

  const handleStatusChange = (value) => {
    setStatus(value);
  };

  const handleTaskChange = (value) => {
    setTask(value);
    setProductivetype();
    setBillable();
  };

  const handleSIAChange = (value) => {
    setSIA(value);
  };

  const handleTimeZoneChange = (value) => {
    setTimezone(value);
  };

  const handleProductiveTypeChange = (value) => {
    setProductivetype(value);
    setTask();
  };
  const disableFromDate = (current) => {
    const twoMonthsAgo = dayjs().subtract(2, "month");
    return (
      current && (current.isBefore(twoMonthsAgo) || current.isAfter(dayjs()))
    );
  };


  const disableToDate = (current) => {
    return (
      current &&
      (current.isBefore(fromDate) || current.isAfter(fromDate.add(2, "month")))
    );
  };


  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate.isBefore(date) || toDate.isAfter(date.add(2, "month"))) {
      setToDate(date);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const getISTRangeTimestamps = (fromDate, toDate) => {
    const istStartDate = new Date(fromDate);
    const istEndDate = new Date(toDate);
    istStartDate.setHours(0, 0, 0, 0);
    istEndDate.setHours(23, 59, 59, 999);
    const startDateUTC = new Date(istStartDate.getTime());
    const endDateUTC = new Date(istEndDate.getTime());

    const startTimestamp = startDateUTC.getTime().toString();
    const endTimestamp = endDateUTC.getTime().toString();

    return {
      startTimestamp,
      endTimestamp,
    };
  };


  const buildFilters = () => {
    const { startTimestamp, endTimestamp } = getISTRangeTimestamps(fromDate, toDate);

    return {
      reporttype: currentPage,
      task: task || "",
      service: service || "",
      requestNumber: request || "",
      employeeName: selectedEmployee || "",
      emailId: emailId || "",
      reportingTo: ReportingTo || "",
      startDateTime: startTimestamp,
      endDateTime: endTimestamp,
      billable: billable === "true" ? true : billable === "false" ? false : null,
      status: status || "",
      clientName: clientName || "",
      requestReceivedStartDate: requestReceivedDate ? dayjs(requestReceivedDate.format('YYYY-MM-DD')).startOf('day').format() : null,
      requestReceivedEndDate: requestReceivedDate ? dayjs(requestReceivedDate.format('YYYY-MM-DD')).endOf('day').format() : null,

      requestCompletedStartDate: requestCompletedDate ? dayjs(requestCompletedDate.format('YYYY-MM-DD')).startOf('day').format() : null,
      requestCompletedEndDate: requestCompletedDate ? dayjs(requestCompletedDate.format('YYYY-MM-DD')).endOf('day').format() : null,
      SIA: SIA || "",
      timezone: timezone || "",
      productivetype: productivetype || "",
    }
  };

  const shouldDisableSearchButton =
    Object.values(buildFilters()).filter((value) => {
      return value !== "" && value !== today.format("YYYY-MM-DD");
    }).length === 0;

  const handleSearch = () => {
    if (!fromDate || !toDate) {
      alert("Both From Date and To Date are required!");
      return;
    }
    const filters = buildFilters();
    dispatch(setLoader(true));
    dispatch(fetchAdminReport(filters)).then((results) => {
      PageChange(1);
      dispatch(setLoader(false));
    }).catch(() => {
      dispatch(setLoader(false));
    });
  };
  const filteredTaskOptions = currentPage === "/ClientReport"
    ? taskOptions.filter(option => !["Calling", "Linkedin", "Data Processing"].includes(option.value)) // Keep "Email"
    : taskOptions;
  const clearFilters = () => {
    const { startTimestamp, endTimestamp } = getISTRangeTimestamps(today, today);
    dispatch(setLoader(true));
    setSelectedEmployee(null);
    setEmailId("");
    setReportingTo("");
    setStatus("");
    setSIA("");
    setFromDate(today);
    setToDate(today);
    setRequestReceivedDate(null);
    setRequestCompletedDate(null);
    setBillable("both");
    setClientName("");
    setRequest("");
    setService("");
    setTask("");
    setTimezone("");
    setProductivetype();
    const filters = {
      startDateTime: startTimestamp,
      endDateTime: endTimestamp,
    };
    dispatch(fetchAdminReport(filters))
      .then((results) => {
        PageChange(1);
        dispatch(setLoader(false));
      })
      .catch(() => { });
  };
  const resetForm = () => {
    setSelectedEmployee(null);
    setEmailId("");
    setReportingTo("");
    setStatus("");
    setSIA("");
    setFromDate(today);
    setToDate(today);
    setRequestReceivedDate(null);
    setRequestCompletedDate(null);
    setBillable("both");
    setClientName("");
    setRequest("");
    setService("");
    setTask("");
    setTimezone("");
    setProductivetype("");
  }
  useImperativeHandle(ref, () => ({
    resetForm,
  }));

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#e8e7e7",
        borderRadius: "20px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "15px",
        }}
      >

        <SelectInput
          label="Employee Name"
          options={employeeOptions}
          value={selectedEmployee}
          onChange={handleEmployeeSelect}
          placeholder="Select"
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />

        <TextareaField
          label="Email ID"
          type="email"
          value={emailId}
          onChange={(e) => setEmailId(e.target.value)}
          placeholder="Enter Email"

          rows={1}
          style={{ width: "100%" }}
        />


        <DatePickerField
          label="From Date"
          format={"DD-MM-YYYY"}
          value={fromDate}
          onChange={handleFromDateChange}
          disabledDate={disableFromDate}
          placeholder="Select From Date"
          allowClear={false}
          style={{ width: "100%" }}
        />


        <DatePickerField
          label="To Date"
          value={toDate}
          format={"DD-MM-YYYY"}
          onChange={handleToDateChange}
          disabledDate={disableToDate}
          placeholder="Select To Date"
          allowClear={false}
          style={{ width: "100%" }}
        />


        {currentPage === "/ClientReport" && (
          <SelectInput
            label="Billable"
            options={billableOptions}
            value={billable}
            onChange={handleBillableChange}
            placeholder="Select"
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (

          <  SelectInput
            label="Reporting To"
            options={ReportManagers}
            value={ReportingTo}
            onChange={handleReportingManagerSelect}
            placeholder="Select Reporting Manager"
            showSearch={false}
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (
          <SelectInput
            label="Client Name"
            options={
              clientOptions
                ? clientOptions
                  .filter((client) => client.status === "Active" || client.status === "active")
                  .map((client) => ({
                    value: client.clientName,
                    label: client.clientName,
                  }))
                : []
            }
            value={clientName}
            onChange={setClientName}
            placeholder="Select"
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (
          <SelectInput
            label="Service"
            options={serviceOptions}
            value={service}
            onChange={setService}
            placeholder="Select"

            style={{ width: "100%" }}
          />
        )}


        <SelectInput
          label="Task"
          options={filteredTaskOptions}
          value={task}
          onChange={handleTaskChange}
          placeholder="Select"
          style={{ width: "100%" }}
        />

        {currentPage === "/ClientReport" && (
          <TextareaField
            label="Request"
            type="text"
            value={request}
            onChange={(e) => setRequest(e.target.value.trim())}
            placeholder="Enter Request Number"
            rows={1}
            style={{ width: "100%" }}
          />
        )}

        {currentPage === "/ClientReport" && (
          <DatePickerField
            label="Request Received"
            value={requestReceivedDate}
            onChange={setRequestReceivedDate}
            disabledDate={(current) => current && current.isAfter(dayjs())}
            placeholder="Select Request Received Date"
            format={"DD-MM-YYYY"}
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (
          <DatePickerField
            label="Request Completed"
            value={requestCompletedDate}
            onChange={setRequestCompletedDate}
            disabledDate={(current) => current && current.isAfter(dayjs())}
            placeholder="Select Request Completed Date"
            format={"DD-MM-YYYY"}
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (
          <SelectInput
            label="Status"
            options={statusOptions}
            value={status}
            onChange={handleStatusChange}
            placeholder="Select"
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/ClientReport" && (
          <SelectInput
            label="SLA Missed"
            options={siaOptions}
            value={SIA}
            onChange={handleSIAChange}
            placeholder="Select"
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/SalesReport" && (
          <SelectInput
            label="Time Zone"
            options={timeZoneOptions}
            value={timezone}
            onChange={handleTimeZoneChange}
            placeholder="Select"
            style={{ width: "100%" }}
          />
        )}


        {currentPage === "/SalesReport" && (
          <SelectInput
            label="Productive Type"
            options={productiveTypeOptions}
            value={productivetype}
            onChange={handleProductiveTypeChange}
            placeholder="Select"
            allowClear
            style={{ width: "100%" }}
          />
        )}

      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <AntdButton
          label="Clear"
          onClick={clearFilters}
          style={{ color: "white", backgroundColor: "#837F7F" }}
        />
        <AntdButton
          label="Search"
          style={{
            backgroundColor: "#007bff",
            color: "white",
          }}
          onClick={handleSearch}
          disabled={shouldDisableSearchButton}
        />
      </div>
    </div>
  );
});

export default EmployeeReportFilter;